import type { NavigationTree } from '@/ds/types/navigation';

export const navigation: NavigationTree[] = [
  {
    id: 'main',
    type: 'group',
    title: 'Main',
    childs: [
      { id: 'dashboard', type: 'item', path: '/', title: 'Dashboard', icon: 'home' },
      { id: 'sources', type: 'item', path: '/sources', title: 'Sources', icon: 'sources' },
      { id: 'personas', type: 'item', path: '/personas', title: 'Personas', icon: 'personas' },
      { id: 'content', type: 'item', path: '/content', title: 'Content Pipeline', icon: 'content' },
      { id: 'settings', type: 'item', path: '/settings', title: 'Settings', icon: 'settings' },
    ],
  },
  {
    id: 'tools',
    type: 'group',
    title: 'Tools',
    childs: [
      {
        id: 'playground',
        type: 'item',
        path: '/playground',
        title: 'Transform',
        icon: 'playground',
      },
      {
        id: 'persona-studio',
        type: 'collapse',
        path: '/persona-studio',
        title: 'Persona Studio',
        icon: 'persona-studio',
        childs: [
          { id: 'persona-studio.library', type: 'item', path: '/persona-studio', title: 'Library' },
          {
            id: 'persona-studio.create',
            type: 'item',
            path: '/persona-studio/create',
            title: 'Create',
          },
          {
            id: 'persona-studio.playground',
            type: 'item',
            path: '/persona-studio/playground',
            title: 'Playground',
          },
        ],
      },
    ],
  },
  {
    id: 'iherb',
    type: 'group',
    title: 'iHerb',
    childs: [
      { id: 'iherb.posts', type: 'item', path: '/iherb-posts', title: 'Posts', icon: 'inbox' },
    ],
  },
  {
    id: 'poc',
    type: 'group',
    title: 'Prototype',
    childs: [
      {
        id: 'poc.wizards',
        type: 'collapse',
        path: '/poc/wizards',
        title: 'Persona Wizards',
        icon: 'chart-bar',
        childs: [
          {
            id: 'poc.wizards.step-by-step',
            type: 'item',
            path: '/poc/wizards/step-by-step',
            title: 'Step-by-Step',
          },
          {
            id: 'poc.wizards.interview',
            type: 'item',
            path: '/poc/wizards/interview',
            title: 'Interview Style',
          },
          {
            id: 'poc.wizards.template',
            type: 'item',
            path: '/poc/wizards/template',
            title: 'Template Based',
          },
          {
            id: 'poc.wizards.live-preview',
            type: 'item',
            path: '/poc/wizards/live-preview',
            title: 'Live Preview',
          },
        ],
      },
      {
        id: 'poc.source-modeling',
        type: 'collapse',
        path: '/poc/source-modeling',
        title: 'Source Modeling',
        icon: 'list',
        childs: [
          {
            id: 'poc.source-modeling.overview',
            type: 'item',
            path: '/poc/source-modeling',
            title: 'Overview',
          },
          {
            id: 'poc.source-modeling.progressive',
            type: 'item',
            path: '/poc/source-modeling/progressive',
            title: 'Progressive',
          },
          {
            id: 'poc.source-modeling.simple',
            type: 'item',
            path: '/poc/source-modeling/simple',
            title: 'Simple',
          },
          {
            id: 'poc.source-modeling.flexible',
            type: 'item',
            path: '/poc/source-modeling/flexible',
            title: 'Flexible',
          },
          {
            id: 'poc.source-modeling.pipeline',
            type: 'item',
            path: '/poc/source-modeling/pipeline',
            title: 'Pipeline',
          },
        ],
      },
    ],
  },
];
